import { Card } from "@dea-web/ui";
import styles from "./styles";
import useCss from "../../hooks/useCss";
import type { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  className?: string;
}

const SbuxCard = ({ children, className = "root" }: Props) => {
  const classes = useCss(styles);
  return <Card className={classes[className]}>{children}</Card>;
};

export default SbuxCard;
